import * as style from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { Fill, Stroke } from 'ol/style';

export default class OLMapStyles {
    //colors
    static BLACK = [0, 0, 0, 1];
    static VERY_DARK_GRAY_ALMOST_BLACK = [38, 38, 38, 1];
    static MEDIUM_GRAY = [77, 77, 77, 1];
    static VERY_DARK_GRAY = [89, 89, 89, 1];
    static VERY_DARK_GRAY_20_TRANSPARENT = [89, 89, 89, 0.2];
    static VERY_DARK_GRAY_80_TRANSPARENT = [89, 89, 89, 0.8];
    static DARK_GRAY = [140, 140, 140, 1];
    static DARK_GRAY_20_TRANSPARENT = [140, 140, 140, 0.2];
    static DARK_GRAY_80_TRANSPARENT = [140, 140, 140, 0.8];
    static GRAY = [191, 191, 191, 1];
    static GRAY_20_TRANSPARENT = [191, 191, 191, 0.2];
    static GRAY_80_TRANSPARENT = [191, 191, 191, 0.8];
    static LIGHT_GRAY = [215, 215, 215, 1];
    static BLACK_90_TRANSPARENT = [0, 0, 0, 0.1];
    static BLACK_50_TRANSPARENT = [0, 0, 0, 0.5];
    static CANARY = [255, 255, 153, 1];
    static CANARY_50_TRANSPARENT = [255, 255, 153, 0.5];
    static ORANGE = [255, 165, 0, 1];
    static ORANGE_20_TRANSPARENT = [255, 165, 0, 0.2];
    static ORANGE_30_TRANSPARENT = [255, 165, 0, 0.3];
    static ORANGE_80_TRANSPARENT = [255, 165, 0, 0.8];
    static BLUE = [0, 0, 255, 1];
    static BLUE_CYAN = [96, 177, 204, 1];
    static BLUE_80_TRANSPARENT = [0, 0, 255, 0.8];
    static BLUE_50_TRANSPARENT = [0, 0, 255, 0.5];
    static BLUE_20_TRANSPARENT = [0, 0, 255, 0.2];
    static WHITE = [255, 255, 255, 1];
    static WHITE_20_TRANSPARENT = [255, 255, 255, 0.2];
    static WHITE_80_TRANSPARENT = [255, 255, 255, 0.8];
    static PINK = [255, 0, 255, 1];
    static LIME = [0, 255, 0, 1];
    static GOLD = [255, 215, 0, 1];
    static GOLD_50_TRANSPARENT = [255, 215, 0, 0.5];
    static YELLOW = [255, 255, 0, 1];
    static YELLOW_80_TRANSPARENT = [255, 255, 0, 0.8];
    static YELLOW_20_TRANSPARENT = [255, 255, 0, 0.2];
    static RED = [255, 0, 0, 1];
    static RED_20_TRANSPARENT = [255, 0, 0, 0.2];
    static RED_50_TRANSPARENT = [255, 0, 0, 0.5];
    static RED_80_TRANSPARENT = [255, 0, 0, 0.8];
    static GREEN = [0, 255, 0, 1];
    static GREEN_20_TRANSPARENT = [0, 255, 0, 0.2];
    static GREEN_50_TRANSPARENT = [0, 255, 0, 0.5];
    static MONALISA = [255, 175, 175, 1];
    static APACHE = [211, 169, 92, 1];
    static APACHE_50_TRANSPARENT = [211, 169, 92, 0.5];
    static PURPLE_20_TRANSPARENT = [145, 48, 222, 0.2];
    static PURPLE = [145, 48, 222, 1];

    static CYAN = [91, 169, 196];
    static GRAISH = [135, 137, 137];
    static SHAMEROCK = [46, 204, 113];
    static SHAMEROCK_60_TRANSPARENT = [46, 204, 113, 0.6];

    static AERODROME_TARGET_PATH_D_SVG =
        'M 11 1 L 11 3.0313 C 6.7957 3.4828 3.4828 6.7957 3 11 L 0 11 L 0 13 L 3.0313 13 C 3.4828 17.2043 6.7957 20.5172 11 20.9688 L 11 24 L 13 24 L 13 20.9688 C 17.2043 20.5172 20.5172 17.2043 20.9688 13 L 24 13 L 24 11 L 20.9688 11 C 20.5172 6.7957 17.2043 3.4828 13 3.0313 L 13 0 L 11 0 z M 12 5 C 15.9 5 19 8.1 19 12 C 19 15.9 15.9 19 12 19 C 8.1 19 5 15.9 5 12 C 5 8.1 8.1 5 12 5 z';

    //line styles
    static LINE_DASH = [2, 4];

    //others
    static SELECTED_ZINDEX = 1000;
    static UNSELECTED_ZINDEX = 100;

    public static readonly TRAJECTORY_DASH_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.BLUE_CYAN,
            width: 2,
            lineDash: OLMapStyles.LINE_DASH,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly TRAJECTORY_SOLID_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.BLUE_CYAN,
            width: 2,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly ICAO_ROUTE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: '#840058',
            width: 2,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly POINT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.CANARY,
            width: 1,
        }),
        fill: new style.Fill({
            color: OLMapStyles.CANARY_50_TRANSPARENT,
        }),
        image: new style.RegularShape({
            stroke: new style.Stroke({
                color: OLMapStyles.CANARY,
                width: 1,
            }),
            fill: new style.Fill({
                color: OLMapStyles.CANARY_50_TRANSPARENT,
            }),
            points: 4,
            radius: 3,
            angle: Math.PI / 4,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly SELECTED_TRAJECTORY_SOLID_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE,
            width: 2,
        }),
        zIndex: OLMapStyles.SELECTED_ZINDEX,
    });

    public static readonly SELECTED_TRAJECTORY_DASH_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE,
            width: 2,
            lineDash: OLMapStyles.LINE_DASH,
        }),
        zIndex: OLMapStyles.SELECTED_ZINDEX,
    });

    public static readonly SELECTED_POINT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE,
            width: 2,
        }),
        fill: new style.Fill({ color: OLMapStyles.CANARY_50_TRANSPARENT }),
        text: new style.Text({
            offsetX: 6,
            offsetY: 6,
            font: 'bold 12px arial',
            fill: new style.Fill({ color: OLMapStyles.BLACK_50_TRANSPARENT }),
            stroke: new style.Stroke({
                color: OLMapStyles.WHITE,
                width: 2,
            }),
        }),
        image: new style.RegularShape({
            stroke: new style.Stroke({
                color: OLMapStyles.WHITE,
                width: 2,
            }),
            fill: new style.Fill({
                color: OLMapStyles.CANARY_50_TRANSPARENT,
            }),
            points: 4,
            radius: 3,
            angle: Math.PI / 4,
        }),
        zIndex: OLMapStyles.SELECTED_ZINDEX,
    });

    public static readonly DEFAULT_LABEL_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: 'bold 12px arial',
            fill: new style.Fill({ color: OLMapStyles.BLACK }),
            stroke: new style.Stroke({ color: OLMapStyles.WHITE, width: 2 }),
        }),
    });

    public static readonly FLIGHT_AIRSPACE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            width: 2,
            color: OLMapStyles.ORANGE,
        }),
        fill: new style.Fill({ color: OLMapStyles.ORANGE_30_TRANSPARENT }),
        text: new style.Text({
            font: 'bold 12px arial',
            fill: new style.Fill({ color: [0, 0, 0, 1] }),
            stroke: new style.Stroke({ color: OLMapStyles.WHITE, width: 2 }),
        }),
    });

    public static readonly AUA_CROSSING_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.PINK,
            width: 10,
        }),
        text: new style.Text({
            font: 'bold 12px sans-serif',
            offsetY: 30,
            offsetX: 30,
            stroke: new style.Stroke({ color: OLMapStyles.WHITE }),
            fill: new style.Fill({ color: OLMapStyles.PINK }),
        }),
    });

    public static readonly AIRSPACE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.LIME,
            width: 2,
        }),
    });

    public static readonly AIRSPACE_STYLE_SCENARIO_OFFLOAD: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.RED_20_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.RED_20_TRANSPARENT,
        }),
    });

    public static readonly AIRSPACE_STYLE_SCENARIO_ONLOAD: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.GREEN_20_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.GREEN_20_TRANSPARENT,
        }),
    });

    public static readonly TV_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            width: 2,
            color: OLMapStyles.MEDIUM_GRAY,
        }),
        fill: new style.Fill({
            color: OLMapStyles.VERY_DARK_GRAY_ALMOST_BLACK,
        }),
        text: new style.Text({
            font: 'bold 10px sans-serif',
        }),
    });

    public static readonly CONVECTION_TV_STYLE: style.Style = new style.Style({
        zIndex: -1,
        stroke: new style.Stroke({
            lineDash: [1],
            width: 2,
            color: OLMapStyles.MEDIUM_GRAY,
        }),
        fill: new style.Fill({
            color: OLMapStyles.VERY_DARK_GRAY_ALMOST_BLACK,
        }),
        text: new style.Text({
            font: 'bold 10px sans-serif',
        }),
    });

    public static readonly NAVPOINT_STYLE: style.Style = new style.Style({
        /*stroke: new style.Stroke({
            width: 2,
            color: OLMapStyles.BLACK
        }),
        fill: new style.Fill({
            color: OLMapStyles.BLACK
        }),*/
        text: new style.Text({
            font: 'bold 12px arial',
            offsetX: 0,
            offsetY: -15,
            fill: new style.Fill({ color: OLMapStyles.BLACK }),
            stroke: new style.Stroke({ color: OLMapStyles.WHITE }),
        }),
        image: new style.RegularShape({
            // stroke: new style.Stroke({color: OLMapStyles.BLACK, width: 2}),
            // fill: new style.Fill({color: OLMapStyles.GOLD}),
            points: 3,
            radius: 10,
            rotation: 0,
            angle: 0,
        }),
    });

    public static readonly AERODROME_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: 'bold 11px arial',
            offsetX: 0,
            offsetY: -15,
            fill: new style.Fill({ color: OLMapStyles.BLACK }),
            stroke: new style.Stroke({ color: OLMapStyles.WHITE, width: 2 }),
        }),
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: OLMapStyles.BLACK, width: 2 }),
            fill: new style.Fill({ color: OLMapStyles.LIME }),
            points: 5,
            radius: 7,
            radius2: 3,
            angle: 0,
        }),
    });

    public static readonly SECTOR_CONFIGURATION_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            width: 2,
            color: OLMapStyles.ORANGE,
        }),
        text: new style.Text({
            font: 'bold 11px arial',
        }),
    });

    public static readonly REGULATION_LESS_15_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.VERY_DARK_GRAY_80_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.VERY_DARK_GRAY_20_TRANSPARENT,
        }),
    });

    public static readonly REGULATION_LESS_30_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.DARK_GRAY_80_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.DARK_GRAY_20_TRANSPARENT,
        }),
    });

    public static readonly REGULATION_LESS_45_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.GRAY_80_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.GRAY_20_TRANSPARENT,
        }),
    });

    public static readonly REGULATION_MORE_45_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE_80_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.WHITE_20_TRANSPARENT,
        }),
    });

    public static readonly HOTSPOT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.SHAMEROCK_60_TRANSPARENT,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.SHAMEROCK_60_TRANSPARENT,
        }),
    });

    public static readonly ENROUTE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.GREEN,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.GREEN,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly SID_ROUTE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.BLUE,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.BLUE,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly STAR_ROUTE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.MONALISA,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.MONALISA,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly ENROUTE_LABEL_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: '14 px arial',
            stroke: new style.Stroke({
                color: OLMapStyles.WHITE,
                width: 5,
            }),
            fill: new style.Fill({
                color: OLMapStyles.GREEN,
            }),
        }),
    });

    public static readonly SID_LABEL_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: '14 px arial',
            stroke: new style.Stroke({
                color: OLMapStyles.WHITE,
                width: 5,
            }),
            fill: new style.Fill({
                color: OLMapStyles.BLUE,
            }),
        }),
    });

    public static readonly STAR_LABEL_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: '14 px arial',
            stroke: new style.Stroke({
                color: OLMapStyles.WHITE,
                width: 5,
            }),
            fill: new style.Fill({
                color: OLMapStyles.MONALISA,
            }),
        }),
    });

    public static readonly CLOSEST_POINT_STYLE: style.Style = new style.Style({
        image: new CircleStyle({
            radius: 3,
            fill: new style.Fill({
                color: OLMapStyles.BLACK,
            }),
            stroke: new style.Stroke({
                color: OLMapStyles.BLACK,
                width: 2,
            }),
        }),
    });

    public static readonly CLOSEST_POINT_LINE_STYLE_WARNING: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.RED,
        }),
    });

    public static readonly CONVECTION_LEVEL_ZERO_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE,
            width: 1,
        }),
    });

    public static readonly CONVECTION_LEVEL_ONE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.YELLOW,
            width: 1,
        }),
        fill: new style.Fill({
            color: OLMapStyles.YELLOW_20_TRANSPARENT,
        }),
    });

    public static readonly CONVECTION_LEVEL_TWO_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.ORANGE,
            width: 1,
        }),
        fill: new style.Fill({
            color: OLMapStyles.ORANGE_20_TRANSPARENT,
        }),
    });

    public static readonly CONVECTION_LEVEL_THREE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.RED,
            width: 1,
        }),
        fill: new style.Fill({
            color: OLMapStyles.RED_20_TRANSPARENT,
        }),
    });

    public static readonly CONVECTION_LEVEL_FOUR_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.PURPLE,
            width: 1,
        }),
        fill: new style.Fill({
            color: OLMapStyles.PURPLE_20_TRANSPARENT,
        }),
    });

    //TV style
    private static readonly OPACITY: number = 0.5;
    //NEUTRAL
    public static readonly TV_ALERT_NEUTRAL_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [48, 51, 51, OLMapStyles.OPACITY],
        }),
        stroke: new style.Stroke({
            color: OLMapStyles.BLACK,
            width: 0.5,
        }),
    });
    public static readonly TV_ALERT_ORANGE_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [94, 74, 48, OLMapStyles.OPACITY],
        }),
        zIndex: 1,
    });
    public static readonly TV_FUTURE_ALERT_ORANGE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [203, 149, 50],
            width: 1,
        }),
    });
    public static readonly TV_FUTURE_ALERT_RED_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [216, 46, 47],
            width: 1,
        }),
    });
    public static readonly TV_FUTURE_ALERT_ORANGE_NON_MONIT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [203, 149, 50],
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });
    public static readonly TV_FUTURE_ALERT_RED_NON_MONIT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [216, 46, 47],
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });

    public static readonly TV_FAR_FUTURE_ALERT_ORANGE_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [88, 73, 55],
            width: 1,
        }),
    });
    public static readonly TV_FAR_FUTURE_ALERT_RED_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [96, 56, 55],
            width: 1,
        }),
    });
    public static readonly TV_FAR_FUTURE_ALERT_ORANGE_NON_MONIT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [88, 73, 55],
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });
    public static readonly TV_FAR_FUTURE_ALERT_RED_NON_MONIT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [96, 56, 55],
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });

    public static readonly TV_ALERT_RED_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [103, 51, 44, OLMapStyles.OPACITY],
        }),
    });
    public static readonly TV_SELECTED_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.CYAN,
            width: 1,
        }),
        zIndex: 2,
    });
    public static readonly TV_NEUTRAL_NON_MONIT_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.GRAISH,
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });
    public static readonly TVL_NON_MONIT_SELECTED_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.CYAN,
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
        zIndex: 2,
    });

    //ORANGE ALERT
    public static readonly TV_ORANGE_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [94, 74, 48],
        }),
    });

    public static readonly TV_ORANGE_NON_MONIT_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [94, 74, 48, OLMapStyles.OPACITY],
        }),
        stroke: new style.Stroke({
            color: OLMapStyles.GRAISH,
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
        // zIndex: 1
    });

    //RED ALERT
    public static readonly TV_RED_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [103, 51, 44],
        }),
    });

    public static readonly TV_RED_NON_MONIT_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [103, 51, 44, OLMapStyles.OPACITY],
        }),
        stroke: new style.Stroke({
            color: OLMapStyles.GRAISH,
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });
    public static readonly TV_RED_NON_MONIT_SELECTED_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [103, 51, 44],
        }),
        stroke: new style.Stroke({
            color: OLMapStyles.CYAN,
            width: 1,
            lineDash: OLMapStyles.LINE_DASH,
        }),
    });

    //TV CONCERNED BY
    public static readonly TV_CONCERNED_BY_SELECTION: style.Style = new style.Style({
        image: new style.Circle({
            radius: 5,
            stroke: new style.Stroke({
                color: '#fff',
                width: 1,
            }),
            fill: new style.Fill({
                color: OLMapStyles.CYAN,
            }),
        }),
    });

    //AERODROME
    public static readonly AERODROME_NEUTRAL_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [140, 139, 139],
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly AERODROME_NEUTRAL_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.CYAN,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly AERODROME_NEUTRAL_NON_MONIT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [140, 139, 139],
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.5" fill="none" stroke="%238C8B8B" stroke-width="2" stroke-dasharray="2"/><g transform="translate(3 3) scale(0.75 0.75)"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></g></svg>`,
        }),
    });

    public static readonly AERODROME_ORANGE_ALERT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [208, 151, 51],
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%23D09733" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly AERODROME_ORANGE_ALERT_NON_MONIT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [208, 151, 51],
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%23D09733" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.5" fill="none" stroke="%23D09733" stroke-width="2" stroke-dasharray="2"/><g transform="translate(3 3) scale(0.75 0.75)"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></g></svg>`,
        }),
    });

    public static readonly AERODROME_RED_ALERT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [229, 45, 47],
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%23E52D2F" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly AERODROME_RED_ALERT_NON_MONIT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: [229, 45, 47],
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%23E52D2F" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.5" fill="none" stroke="%23E52D2F" stroke-width="2" stroke-dasharray="2"/><g transform="translate(3 3) scale(0.75 0.75)"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></g></svg>`,
        }),
    });

    public static readonly AERODROME_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.CYAN,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%235BA9C4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly AERODROME_SELECTED_NON_MONIT_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.CYAN,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%235BA9C4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.5" fill="none" stroke="%235BA9C4" stroke-width="2" stroke-dasharray="2"/><g transform="translate(3 3) scale(0.75 0.75)"><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></g></svg>`,
        }),
    });

    //WAYPOINT
    public static readonly NAVPOINT_NEUTRAL_STYLE: style.Style = new style.Style({
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: [140, 139, 139], width: 2 }),
            points: 3,
            radius: 10,
            rotation: 0,
            angle: 0,
        }),
    });
    public static readonly NAVPOINT_ORANGE_ALERT_STYLE: style.Style = new style.Style({
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: [208, 151, 51], width: 2 }),
            points: 3,
            radius: 10,
            rotation: 0,
            angle: 0,
        }),
    });
    public static readonly NAVPOINT_RED_ALERT_STYLE: style.Style = new style.Style({
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: [229, 45, 47], width: 2 }),
            points: 3,
            radius: 10,
            rotation: 0,
            angle: 0,
        }),
    });

    //MEASURE
    //it has the biggest size possible then when applying the style it's just a matter of changing the scale
    //example: let style = OLMapStyles.MEASURE_STYLE.clone(); style.getImage().setScale(0.5)
    public static readonly MEASURE_STYLE: style.Style = new style.Style({
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: 'white', width: 2 }),
            fill: new style.Fill({ color: [255, 255, 255, 0.5] }),
            points: 4,
            radius: 10,
            rotation: 0,
            angle: Math.PI / 4,
        }),
    });
    public static readonly MEASURE_AIRSPACE_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: [0, 0, 0, 0],
        }),
        stroke: new style.Stroke({
            color: [0, 0, 0, 0],
            width: 1,
        }),
        // zIndex: 1
    });
    public static readonly MEASURE_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.RegularShape({
            stroke: new style.Stroke({ color: OLMapStyles.CYAN, width: 2 }),
            fill: new style.Fill({ color: OLMapStyles.CYAN }),
            points: 4,
            radius: 10,
            rotation: 0,
            angle: Math.PI / 4,
        }),
    });
    public static readonly HOTSPOT_AERODROME_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.SHAMEROCK,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly REGULATION_OUTLOOK_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: 'tan',
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly HOTSPOT_AERODROME_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.CYAN,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.WHITE,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_CANCEL_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.RED,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_TERMINATED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.VERY_DARK_GRAY,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.CYAN,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_CANCEL_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.RED,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_TERMINATED_SELECTED_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.VERY_DARK_GRAY,
            scale: 0.8,
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });

    public static readonly MEASURE_AERODROME_LESS_15_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.VERY_DARK_GRAY_80_TRANSPARENT,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_LESS_30_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.DARK_GRAY_80_TRANSPARENT,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_LESS_45_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.GRAY_80_TRANSPARENT,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });
    public static readonly MEASURE_AERODROME_MORE_45_STYLE: style.Style = new style.Style({
        image: new style.Icon({
            opacity: 1,
            color: OLMapStyles.WHITE_80_TRANSPARENT,
            scale: 0.8,
            //adding a rect so the selection area doesn't have holes (center of the icon circle), with opacity zero doesn't work - 0,05 was the minimum that worked
            src: `data:image/svg+xml;utf8,<svg width="24" height="24" fill="%238C8B8B" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="100" height="100" fill-opacity="0.05"/><path stroke-width="3" d="${OLMapStyles.AERODROME_TARGET_PATH_D_SVG}"/></svg>`,
        }),
    });

    //GENERIC
    public static readonly SELECTABLE_LABEL_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: 'bold 12px arial',
            fill: new style.Fill({ color: OLMapStyles.WHITE }),
            padding: [2, 0, 0, 2],
            placement: 'point',
            justify: 'center',
            textAlign: 'center',
            backgroundFill: new style.Fill({ color: OLMapStyles.BLACK }),
        }),
    });
    public static readonly SELECTABLE_LABEL_SELECTED_STYLE: style.Style = new style.Style({
        text: new style.Text({
            font: 'bold 12px arial',
            fill: new style.Fill({ color: OLMapStyles.WHITE }),
            padding: [2, 0, 0, 2],
            placement: 'point',
            justify: 'center',
            textAlign: 'center',
            backgroundFill: new style.Fill({ color: OLMapStyles.CYAN }),
        }),
    });

    //ACC
    public static readonly ACC_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.LIGHT_GRAY,
            width: 1,
        }),
    });
    public static readonly ACC_SELECTED_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: [101, 121, 213, 1],
            width: 1,
        }),
        fill: new style.Fill({
            color: [101, 121, 213, 0.5],
        }),
    });

    //MILITARY
    public static readonly MILITARY_ZONE_STYLE: style.Style = new style.Style({
        fill: new style.Fill({
            color: OLMapStyles.BLACK,
        }),
    });

    //NAT TRACKS
    public static readonly NAT_TRACKS_STYLE: style.Style = new style.Style({
        stroke: new style.Stroke({
            color: OLMapStyles.WHITE,
            width: 2,
        }),
        fill: new style.Fill({
            color: OLMapStyles.WHITE,
        }),
        zIndex: OLMapStyles.UNSELECTED_ZINDEX,
    });

    public static readonly SCENARIO_POLYGON_STYLE: style.Style = new style.Style({
        stroke: new Stroke({ color: 'rgba(0,0,255,0.6)', width: 2 }),
        fill: new Fill({ color: 'rgba(0,0,255,0.2)' }),
        image: new CircleStyle({
            radius: 5,
            fill: new Fill({ color: '#00f' }),
            stroke: new Stroke({ color: '#fff', width: 1 }),
        }),
    });
}
